import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import '../../styles/theme.scss';
import '../../styles/theme.scss.liquid';

import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';
// import {cookiesEnabled} from '@shopify/theme-cart';

// Common a11y fixes
focusHash();
bindInPageLinks();

// // Apply a specific class to the html element for browser support of cookies.
// if (cookiesEnabled()) {
//   document.documentElement.className = document.documentElement.className.replace(
//     'supports-no-cookies',
//     'supports-cookies',
//   );
// }

if (window.navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}

$('.mobile-callouts').slick({
  arrows: true,
  dots: false,
  slidesToShow: 3,
  autoplay: false,
  responsive: [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  },
  ]
});

$( ".megamenu.megamenu-click  .megamenu-item-parent > a" ).click(function(e) {
  e.preventDefault();
  var id = $(this).data('id');
  $('.megamenu-nav-children[data-id!="'+id+'"]').removeClass('active');
  $('.megamenu-nav-children[data-id="'+id+'"]').addClass('active');
});

$( ".megamenu.megamenu-hover .megamenu-item-parent > a" ).hover(function(e) {
  e.preventDefault();
  var id = $(this).data('id');
  $('.megamenu-nav-children[data-id!="'+id+'"]').removeClass('active');
  $('.megamenu-nav-children[data-id="'+id+'"]').addClass('active');
  $(".megamenu-single-item").hover(function(e) {
    $('.megamenu-nav-children').removeClass('active');
  });
});

$( ".header-main").mouseleave(function(e) {
  $('.megamenu-nav-children').removeClass('active');
});

$(".dropdown-toggle").click(function(e) {
  e.preventDefault();
  $(this).closest(".dropdown").toggleClass("active");
  $(this).blur();
});

function setMainMinHeight(){
  var footerHeight = $('#shopify-section-footer').height()
  var headerHeight = $('#shopify-section-header').height()
  var calloutHeight = $('#shopify-section-callout').height()
  var minMainContentHeight = $(window).height() - footerHeight - headerHeight - calloutHeight;

  $('#MainContent').css("min-height", minMainContentHeight + "px")
}

$( window ).resize(function() {
  setMainMinHeight()
});

$( document ).ready(function() {
  setMainMinHeight()
});

$('.productimg-link').click(function(){
    event.preventDefault();

    $('a[href*="#"]').removeClass('active');

      $(this).addClass('active');

    $('html, body').animate({
        scrollTop: $( $.attr(this, 'href') ).offset().top
    }, 500);
    return false;
});


// Ajax Newsletter Modal Form
//======================================================
//Used for popup email form only for customer email sign up
//====================================================================
$('.newsletter-section #contact_form').submit(function(e) {
  event.preventDefault();
  var data = $(this).serialize();

 //create new account
  $.post('/contact', data)
    .done(function(data){
    var logErrors = $(data).find('.errors').text();

    //if there are errors show them in the html form
    if (logErrors.trim() != "" && logErrors.trim() != 'undefined'){
        $('.newsletteraccount-email-form .errors').html(logErrors);
        $('.newsletteraccount-email-form .errors').addClass('show');
    } else {
       $('.newsletter-section .errors').addClass('hide');
       $('.newsletter-section .toast-success').addClass('show');
       $('.form-elements').hide();
       $('.newsletter-subtitle').hide();
       $('.newsletter-title').hide();
    }
   }).fail(function(){console.log('error');});
   return false;

   $('.btn-clear').click(function() {
      $(this).closest('.modal').hide();
   });
});

function incrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal)) {
    parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(1);
  }

  if (currentVal > 1) {
    $('.button-minus').prop('disabled', false);
  }
}

function decrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

  if (!isNaN(currentVal) && currentVal > 1) {
    parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
    $('.button-minus').prop('disabled', false);
  } else if (currentVal == 1) {
    parent.find('input[name=' + fieldName + ']').val(0);
    $('.button-minus').prop('disabled', true);
  } else {
    parent.find('input[name=' + fieldName + ']').val(0);
  }
}

$('.input-group').on('click', '.button-plus', function(e) {
  $('.quantity-field').trigger('change');
  incrementValue(e);
});

$('.input-group').on('click', '.button-minus', function(e) {
  $('.quantity-field').trigger('change');
  decrementValue(e);
});

$('.close-modal').click(function(e) {
   e.preventDefault();
   $(this).closest('.modal').removeClass('active');
   $(this).closest('.modal').hide();
});

$('.show-modal').click(function(e) {
   $(this).closest('.modal').addClass('active');
   $(this).closest('.modal').show();
});

$('.show-cart-delivery-modal').click(function(e) {
   $('.cart-delivery-modal').addClass('active');
   $('.cart-delivery-modal').closest('.modal').show();
});

$('.facts-slider').slick({
  arrows: true,
  dots: false,
  slidesToShow: 3,
  autoplay: false,
  responsive: [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  },
  ]
});
